/**
 * Tipos de planilha atendidos pela fila única de processamento de planilhas de operação.
 * Os valores espelham o enum EnumTipoPlanilhaOperacao do backend.
 */
export const TIPO_PLANILHA_OPERACAO = {
    INIBICAO_ALERTAS: 'INIBICAO_ALERTAS',
    ALTERACAO_OPERACOES: 'ALTERACAO_OPERACOES',
    CANCELAMENTO_OPERACOES: 'CANCELAMENTO_OPERACOES'
};

export default TIPO_PLANILHA_OPERACAO;
